import { render, staticRenderFns } from "./ProDataPoint.vue?vue&type=template&id=661d6e2f&"
import script from "./ProDataPoint.vue?vue&type=script&lang=js&"
export * from "./ProDataPoint.vue?vue&type=script&lang=js&"
import style0 from "./ProDataPoint.vue?vue&type=style&index=0&id=661d6e2f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports